import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Grid, Cell } from '@digsup/components-grid';
import { Form, Yup } from '@digsup/components-form';
import { Text } from '@digsup/components-text';
import { Input } from '@digsup/components-input';
import { Button } from '@digsup/components-button';

export const PartnersForm = ({ onSubmit }) => {
  const signUpFormSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    worktype: Yup.string().required('Required'),
    website: Yup.string()
      .matches(
        // eslint-disable-next-line no-useless-escape
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
        'Invalid Url',
      )
      .required('Required'),
    area: Yup.string().required('Required'),
    phoneArea: Yup.string()
      .min(3, 'must be at least 3 characters')
      .max(3, 'must be at most 3 characters')
      .required('Required'),
    phoneDetail1: Yup.string()
      .min(3, 'must be at least 3 characters')
      .max(3, 'must be at most 3 characters')
      .required('Required'),
    phoneDetail2: Yup.string()
      .min(4, 'must be at least 4 characters')
      .max(4, 'must be at most 4 characters')
      .required('Required'),
    email: Yup.string().email('Invalid Email').required('Required'),
  });

  return (
    <Form
      onSubmit={values => {
        onSubmit({
          FNAME: values.firstName,
          LNAME: values.lastName,
          WORKTYPE: values.worktype,
          WEBSITE: values.website,
          AREA: values.area,
          'PHONE[area]': values.phoneArea,
          'PHONE[detail1]': values.phoneDetail1,
          'PHONE[detail2]': values.phoneDetail2,
          EMAIL: values.email,
        });
      }}
      validationSchema={signUpFormSchema}
      initialValues={{
        firstName: '',
        lastName: '',
        worktype: '',
        website: '',
        area: '',
        phoneArea: '',
        phoneDetail1: '',
        phoneDetail2: '',
        email: '',
      }}>
      {() => (
        <Form.Context>
          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Name
            </Text>
            <Grid gutter="small">
              <Cell columns="6">
                <Form.Field name="firstName">
                  {({ field }) => <Input {...field} placeholder="First Name" />}
                </Form.Field>
              </Cell>
              <Cell columns="6">
                <Form.Field name="lastName">
                  {({ field }) => <Input {...field} placeholder="Last Name" />}
                </Form.Field>
              </Cell>
            </Grid>
          </div>

          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Type of work (brokerage, moving company, etc)
            </Text>
            <Form.Field name="worktype">
              {({ field }) => <Input placeholder="Type of work" {...field} />}
            </Form.Field>
          </div>

          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Website
            </Text>
            <Form.Field name="website">
              {({ field }) => <Input placeholder="Website" {...field} />}
            </Form.Field>
          </div>

          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Area(s) served (cities, counties, states...)
            </Text>
            <Form.Field name="area">
              {({ field }) => <Input placeholder="Area(s) served" {...field} />}
            </Form.Field>
          </div>

          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Phone Number
            </Text>
            <Grid gutter="small">
              <Cell columns="3">
                <Form.Field name="phoneArea">
                  {({ field }) => <Input {...field} placeholder="###" />}
                </Form.Field>
              </Cell>
              <Cell columns="3">
                <Form.Field name="phoneDetail1">
                  {({ field }) => <Input {...field} placeholder="###" />}
                </Form.Field>
              </Cell>
              <Cell columns="6">
                <Form.Field name="phoneDetail2">
                  {({ field }) => <Input {...field} placeholder="####" />}
                </Form.Field>
              </Cell>
            </Grid>
          </div>

          <div className="u-margin-bottom-xlarge">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Email
            </Text>
            <Form.Field name="email">
              {({ field }) => <Input placeholder="Email address" {...field} />}
            </Form.Field>
          </div>

          <div className="u-padding-right-large u-padding-left-large u-padding-right-xxlarge@small u-padding-left-xxlarge@small">
            <Button type="submit" size="large" width="full" variant="primary">
              Send
            </Button>
          </div>
        </Form.Context>
      )}
    </Form>
  );
};

PartnersForm.propTypes = {
  /**
   * onSubmit callback
   */
  onSubmit: PropTypes.func.isRequired,
};
